/* tslint:disable */

declare var Object: any;
export interface SFSearchInterface {
  "id"?: number;
}

export class SFSearch implements SFSearchInterface {
  "id": number;
  constructor(data?: SFSearchInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFSearch`.
   */
  public static getModelName() {
    return "SFSearch";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFSearch for dynamic purposes.
  **/
  public static factory(data: SFSearchInterface): SFSearch{
    return new SFSearch(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFSearch',
      plural: 'SFSearches',
      path: 'SFSearches',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFSearch.ts